import { Tooltip } from '@chakra-ui/react';
import { Icons } from '../Icons';
import { formatDate } from '@texas/utils/helpers/dateHelper';
import { Locale } from '@texas/i18n/types';

export function ArchivedTooltip({
  archived,
  iconSize,
}: {
  archived: string;
  iconSize?: number;
}) {
  return (
    <Tooltip label={formatDate(Locale.En, archived)}>
      <Icons.ArchiveOutline boxSize={iconSize ?? 4} />
    </Tooltip>
  );
}
